interface SpinnerProps {
  className?: string;
}

export default function Spinner({ className = "h-8 w-8" }: SpinnerProps) {
  return (
    <div
      className={`animate-spin rounded-full border-3 border-border border-t-primary ${className}`}
      role="status"
      aria-label="Loading"
    />
  );
}
